/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $SatisfactionSurveyQuestions = {
    type: 'array',
    contains: {
        type: 'SatisfactionSurveyQuestion',
    },
};